import React from "react";
import { StyledList, StyledListItem, ListText } from "./style";

const List = ({ items }) => {
  return (
    <StyledList>
      {items.map((item, index) => (
        <StyledListItem key={index}>
          <ListText>{item.label}</ListText>
        </StyledListItem>
      ))}
    </StyledList>
  );
};

export default List;
